export default (target, width, height) => ({
  open: false,
  originContent: '',
  contentElement: null,
  modal: null,
  target: target,
  close: '',

  handleModal() {
    const source = this.$el.dataset.source;
    const targetContent = this.modal.querySelector('.alpine-modal__content');
    this.getContent(source, targetContent);
  },

  openModal() {
    document.body.classList.add('stop-scrolling');
    this.close.classList.remove('alpine-modal__close--hidden');
    this.modal.classList.add('alpine-modal--open');

    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'lead_form_opened',
    });
  },

  closeModal(close = true) {
    if (close) {
      this.modal.classList.remove('alpine-modal--open');
    }
    this.close.classList.add('alpine-modal__close--hidden');
    document.body.classList.remove('stop-scrolling');
    this.revertContent();
    this.contentElement = null;
  },

  getContent(source, target) {
    this.contentElement = document.getElementById(source);
    if (this.contentElement.querySelector('[data-disable-alpine="true"]')) {
      this.contentElement
        .querySelector('[data-disable-alpine="true"]')
        .setAttribute('x-ignore', 'true');
    }
    this.originContent = this.contentElement.innerHTML;
    this.$dispatch('set-dimensions', {
      height: height ?? 656,
      width: width ?? 1030,
    });
    this.handleContent(target);
    this.openModal();
  },

  revertContent() {
    if (this.contentElement !== null) {
      this.contentElement.innerHTML = this.originContent;
    } else {
      this.modal.querySelector('.alpine-modal__content').innerHTML = '';
    }
  },

  handleContent(target) {
    this.contentElement.innerHTML = '';
    target.innerHTML = this.originContent;
  },

  init() {
    this.modal = document.getElementById(target);
    this.close = this.modal.querySelector('.alpine-modal__close');
  },
});
